import { createRouter, createWebHistory } from 'vue-router'
// import { verifyAuth } from '../middleware/auth';
import LoginPage from '../views/LoginPage.vue';
import DashboardPage from '../views/DashboardPage.vue';

import NotFound from '../views/NotFound.vue';
import ReportsPage from '@/views/ReportsPage.vue';
import HistoryPage from '@/views/HistoryPage.vue';
import TransactionsPage from '@/views/TransactionsPage.vue';
import store from '../store'
import UsersBalancePage from '@/views/UsersBalancePage.vue';
import { viewOnlyUsersBalanceTableId, viewOnlyUsersBalanceTableIdxName } from '@/enums/users';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage,
    meta: { auth: true }
  },
  {
    path: '/dashboard',
    name: 'Home',
    component: DashboardPage,
    meta: { auth: true }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: ReportsPage,
    meta: { auth: true }
  },
  {
    path: '/history',
    name: 'History',
    component: HistoryPage,
    meta: { auth: true }
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: TransactionsPage,
    meta: { auth: true }
  },
  {
    path: '/users-balance',
    name: 'UsersBalance',
    component: UsersBalancePage,
    meta: { auth: true }
  },

  { 
    path: '/:catchAll(.*)',
    name: '404',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.auth);
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const userId = store.getters['auth/userId'];
  const user = store.getters['auth/user'];

  if(requiresAuth) {
    if (isAuthenticated) {
      if (to.name === 'Login') {
        if(viewOnlyUsersBalanceTableId.includes(userId) && viewOnlyUsersBalanceTableIdxName[userId] == user) {
          return next({ name: 'UsersBalance' });
        }else {
          return next({ name: 'Home' });
        }
      } else {
        return next();
      }
    } else {
      if (to.name !== 'Login') {
        return next({ name: 'Login' });
      } else {
        return next();
      }
    }
  } else {
    return next();
  }
});

export default router
